module.exports = __webpack_public_path__ + "static/gpiLogo-bea43934fd43b1ce03f2e4d6e9c2c6fb.png";